var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*eslint no-useless-escape: 0*/
import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, MenuItem, Table, TableHead, TableCell, TableRow, TableBody, Paper, TableContainer, IconButton, Autocomplete, TextField, } from '@mui/material';
import { ModeEditOutlined as ModeEditOutlinedIcon, DeleteOutline as DeleteOutlineIcon } from '@mui/icons-material';
import { MENSAGENS, getCPFFormatado } from '../../../utils';
import { PAGINAS, FUNCIONALIDADES } from '../../../routes';
import ContainerPainel from '../../../components/container_painel';
import { BoxPrincipal } from '../../../components/grid_box';
import Loading from '../../../components/loading';
import { BotaoAuxiliar } from '../../../components/botoes';
import { InputDados } from '../../../components/input_dados';
import BarraPesquisar from '../../../components/grid_pesquisar';
import { buscarColaboradoresVinculo, getVinculos, getBancosVinculo, cadastrarBeneficiario, alterarBeneficiario, excluirBeneficiario } from './vinculos.service';
import { useAuth } from '../../../contexts/auth/AuthContext';
var GRAUS_VINCULO = ['Filho(a)', 'Cônjuge', 'Ex-Cônjuge', 'Genitor(a)', 'Outros'];
var TIPOS_VINCULO = ['Judicial', 'Voluntário'];
export var VinculosGestao = function () {
    var addMensagem = useAuth().addMensagem;
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState(true), LoadingInicio = _b[0], setLoadingInicio = _b[1];
    // Colaborador (Autocomplete)
    var _c = useState([]), ColaboradorOptions = _c[0], setColaboradorOptions = _c[1];
    var _d = useState(''), ColaboradorInput = _d[0], setColaboradorInput = _d[1];
    var _f = useState(null), ColaboradorSelecionado = _f[0], setColaboradorSelecionado = _f[1];
    // Bancos
    var _g = useState([]), BancosDisponiveis = _g[0], setBancosDisponiveis = _g[1];
    // Formulário
    var _h = useState(), EditarID = _h[0], setEditarID = _h[1];
    var _j = useState(''), Nome = _j[0], setNome = _j[1];
    var _k = useState(''), Cpf = _k[0], setCpf = _k[1];
    var _l = useState(''), GrauVinculo = _l[0], setGrauVinculo = _l[1];
    var _m = useState(''), TipoVinculo = _m[0], setTipoVinculo = _m[1];
    var _o = useState(''), BancoId = _o[0], setBancoId = _o[1];
    var _p = useState(''), Agencia = _p[0], setAgencia = _p[1];
    var _q = useState(''), Conta = _q[0], setConta = _q[1];
    var _r = useState(''), Digito = _r[0], setDigito = _r[1];
    var _s = useState({}), Erros = _s[0], setErros = _s[1];
    // Grid de vínculos cadastrados
    var _t = useState([]), Vinculos = _t[0], setVinculos = _t[1];
    var _u = useState(''), Filtro = _u[0], setFiltro = _u[1];
    useEffect(function () {
        inicializar();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        carregarVinculos();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Filtro]);
    var inicializar = function () { return __awaiter(void 0, void 0, void 0, function () {
        var bancos;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getBancosVinculo()];
                case 1:
                    bancos = _a.sent();
                    setBancosDisponiveis(Array.isArray(bancos) ? bancos : []);
                    return [4 /*yield*/, carregarVinculos()];
                case 2:
                    _a.sent();
                    setLoadingInicio(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var carregarVinculos = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, getVinculos(Filtro || null)];
                case 1:
                    Resp = _a.sent();
                    setVinculos(Array.isArray(Resp) ? Resp : []);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var buscarColaboradores = function (texto) { return __awaiter(void 0, void 0, void 0, function () {
        var Resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!texto || texto.trim().length < 3) {
                        setColaboradorOptions([]);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, buscarColaboradoresVinculo(texto)];
                case 1:
                    Resp = _a.sent();
                    setColaboradorOptions(Array.isArray(Resp) ? Resp : []);
                    return [2 /*return*/];
            }
        });
    }); };
    var limpar = function () {
        setEditarID(undefined);
        setColaboradorSelecionado(null);
        setColaboradorInput('');
        setNome('');
        setCpf('');
        setGrauVinculo('');
        setTipoVinculo('');
        setBancoId('');
        setAgencia('');
        setConta('');
        setDigito('');
        setErros({});
    };
    var validar = function () {
        var erros = {};
        if (!(ColaboradorSelecionado === null || ColaboradorSelecionado === void 0 ? void 0 : ColaboradorSelecionado.id))
            erros.colaborador = true;
        if (!Nome || !Nome.trim())
            erros.nome = true;
        if (!Cpf || Cpf.replace(/\D/g, '').length !== 11)
            erros.cpf = true;
        if (!GrauVinculo)
            erros.grau = true;
        if (!TipoVinculo)
            erros.tipo = true;
        if (!BancoId)
            erros.banco = true;
        if (!Agencia || !Agencia.trim())
            erros.agencia = true;
        if (!Conta || !Conta.trim())
            erros.conta = true;
        if (!Digito || !Digito.trim())
            erros.digito = true;
        setErros(erros);
        if (Object.keys(erros).length > 0) {
            alert('Preencha os campos obrigatórios destacados.');
            return false;
        }
        return true;
    };
    var salvar = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Dados, Resp, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!validar())
                        return [2 /*return*/];
                    Dados = {
                        reeducando_id: ColaboradorSelecionado.id,
                        nome: Nome.trim(),
                        cpf: Cpf.replace(/\D/g, ''),
                        grau_vinculo: GrauVinculo,
                        tipo_vinculo: TipoVinculo,
                        banco_id: Number(BancoId),
                        agencia: Agencia.trim(),
                        conta: Conta.trim(),
                        digito: Digito.trim(),
                    };
                    setLoading(true);
                    if (!EditarID) return [3 /*break*/, 2];
                    return [4 /*yield*/, alterarBeneficiario(Dados, String(EditarID))];
                case 1:
                    _a = _c.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, cadastrarBeneficiario(Dados)];
                case 3:
                    _a = _c.sent();
                    _c.label = 4;
                case 4:
                    Resp = _a;
                    setLoading(false);
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) === 'OK' || (Resp === null || Resp === void 0 ? void 0 : Resp.id)) {
                        addMensagem === null || addMensagem === void 0 ? void 0 : addMensagem(EditarID ? MENSAGENS.REGISTRO_ALTERADO_SUCESSO : MENSAGENS.REGISTRO_CADASTRADO_SUCESSO);
                        limpar();
                        carregarVinculos();
                    }
                    else {
                        alert((_b = Resp === null || Resp === void 0 ? void 0 : Resp.Mensagem) !== null && _b !== void 0 ? _b : 'Erro ao salvar o vínculo.');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var editarVinculo = function (v) {
        var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        setEditarID(v.id);
        setColaboradorSelecionado({ id: (_a = v.colaborador) === null || _a === void 0 ? void 0 : _a.id, nome: (_b = v.colaborador) === null || _b === void 0 ? void 0 : _b.nome, cpf: (_c = v.colaborador) === null || _c === void 0 ? void 0 : _c.cpf });
        setColaboradorInput((_f = (_d = v.colaborador) === null || _d === void 0 ? void 0 : _d.nome) !== null && _f !== void 0 ? _f : '');
        setNome((_g = v.nome) !== null && _g !== void 0 ? _g : '');
        setCpf((_h = v.cpf) !== null && _h !== void 0 ? _h : '');
        setGrauVinculo((_j = v.grau_vinculo) !== null && _j !== void 0 ? _j : '');
        setTipoVinculo((_k = v.tipo_vinculo) !== null && _k !== void 0 ? _k : '');
        setBancoId((_l = v.banco_id) !== null && _l !== void 0 ? _l : '');
        setAgencia((_m = v.agencia) !== null && _m !== void 0 ? _m : '');
        setConta((_o = v.conta) !== null && _o !== void 0 ? _o : '');
        setDigito((_p = v.digito) !== null && _p !== void 0 ? _p : '');
        setErros({});
    };
    var excluirVinculo = function (v) { return __awaiter(void 0, void 0, void 0, function () {
        var Resp;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!confirm('Tem certeza que deseja excluir este vínculo?'))
                        return [2 /*return*/];
                    setLoading(true);
                    return [4 /*yield*/, excluirBeneficiario(String(v.id))];
                case 1:
                    Resp = _b.sent();
                    setLoading(false);
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) === 'OK') {
                        addMensagem === null || addMensagem === void 0 ? void 0 : addMensagem('Vínculo excluído com sucesso.');
                        if (EditarID === v.id)
                            limpar();
                        carregarVinculos();
                    }
                    else {
                        alert((_a = Resp === null || Resp === void 0 ? void 0 : Resp.Mensagem) !== null && _a !== void 0 ? _a : 'Erro ao excluir o vínculo.');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getOptionLabel = function (o) {
        if (!o)
            return '';
        var partes = [o.nome, o.cpf && "CPF: ".concat(o.cpf), o.id && "Mat: ".concat(o.id)];
        return partes.filter(Boolean).join(' • ');
    };
    return (_jsx(ContainerPainel, __assign({ pagina: PAGINAS.VINCULOS, pagina_especifica_permissao: FUNCIONALIDADES.VINCULOS }, { children: _jsxs(BoxPrincipal, __assign({ width: '92%' }, { children: [!LoadingInicio && (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: 'h6', gutterBottom: true }, { children: "Gest\u00E3o de V\u00EDnculos" })), _jsxs(Paper, __assign({ variant: 'outlined', sx: { p: 2, borderRadius: 2, mb: 3 } }, { children: [_jsx(Typography, __assign({ variant: 'subtitle1', sx: { fontWeight: 600, mb: 1 } }, { children: EditarID ? 'Editar Vínculo' : 'Novo Vínculo' })), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sm: 8 }, { children: _jsx(Autocomplete, { id: 'colaborador-vinculo', options: ColaboradorOptions, value: ColaboradorSelecionado, inputValue: ColaboradorInput, getOptionLabel: getOptionLabel, isOptionEqualToValue: function (o, v) { return (o === null || o === void 0 ? void 0 : o.id) === (v === null || v === void 0 ? void 0 : v.id); }, filterOptions: function (x) { return x; }, onChange: function (_e, val) { return setColaboradorSelecionado(val); }, onInputChange: function (_e, val) {
                                                    setColaboradorInput(val);
                                                    buscarColaboradores(val);
                                                }, noOptionsText: ColaboradorInput.trim().length < 3 ? 'Digite ao menos 3 caracteres' : 'Nenhum colaborador encontrado', renderInput: function (params) { return _jsx(TextField, __assign({}, params, { label: 'Colaborador *', size: 'small', fullWidth: true, error: Erros.colaborador })); } }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 4 }, { children: _jsx(InputDados, __assign({ select: true, id: 'grau_vinculo', label: 'Grau de V\u00EDnculo *', value: GrauVinculo, onChange: function (e) { return setGrauVinculo(e.target.value); }, error: Erros.grau }, { children: GRAUS_VINCULO.map(function (g) { return (_jsx(MenuItem, __assign({ value: g }, { children: g }), g)); }) })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 5 }, { children: _jsx(InputDados, { id: 'nome_beneficiario', label: 'Nome do Benefici\u00E1rio *', value: Nome, onChange: function (e) { return setNome(e.target.value); }, inputProps: { maxLength: 100 }, error: Erros.nome }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { id: 'cpf_beneficiario', label: 'CPF do Benefici\u00E1rio *', value: Cpf, mask: '999.999.999-99', onChange: function (e) { return setCpf(e.target.value); }, error: Erros.cpf }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 4 }, { children: _jsx(InputDados, __assign({ select: true, id: 'tipo_vinculo', label: 'Tipo de V\u00EDnculo *', value: TipoVinculo, onChange: function (e) { return setTipoVinculo(e.target.value); }, error: Erros.tipo }, { children: TIPOS_VINCULO.map(function (t) { return (_jsx(MenuItem, __assign({ value: t }, { children: t }), t)); }) })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 5 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'banco', label: 'Banco *', value: BancoId, onChange: function (e) { return setBancoId(Number(e.target.value)); }, error: Erros.banco }, { children: [_jsx(MenuItem, __assign({ value: '' }, { children: _jsx("em", { children: "Selecione o Banco" }) })), BancosDisponiveis.map(function (b) { return (_jsx(MenuItem, __assign({ value: b.id }, { children: "".concat(b.codigo, " - ").concat(b.nome) }), b.id)); })] })) })), _jsx(Grid, __assign({ item: true, xs: 6, sm: 3 }, { children: _jsx(InputDados, { id: 'agencia', label: 'Ag\u00EAncia *', value: Agencia, onChange: function (e) { return setAgencia(e.target.value); }, inputProps: { maxLength: 10 }, error: Erros.agencia }) })), _jsx(Grid, __assign({ item: true, xs: 6, sm: 2 }, { children: _jsx(InputDados, { id: 'conta', label: 'Conta *', value: Conta, onChange: function (e) { return setConta(e.target.value); }, inputProps: { maxLength: 20 }, error: Erros.conta }) })), _jsx(Grid, __assign({ item: true, xs: 6, sm: 2 }, { children: _jsx(InputDados, { id: 'digito', label: 'D\u00EDg. *', value: Digito, onChange: function (e) { return setDigito(e.target.value); }, inputProps: { maxLength: 2 }, error: Erros.digito }) }))] })), _jsxs(Box, __assign({ sx: { display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 } }, { children: [_jsx(BotaoAuxiliar, __assign({ backgroundColor: 'secondary.main', onClick: limpar }, { children: "Limpar" })), _jsx(BotaoAuxiliar, __assign({ backgroundColor: 'principal.main', onClick: salvar }, { children: "Salvar V\u00EDnculo" }))] }))] })), _jsx(Typography, __assign({ variant: 'subtitle1', sx: { fontWeight: 600, mb: 1 } }, { children: "V\u00EDnculos Cadastrados" })), _jsx(Box, __assign({ sx: { mb: 1, maxWidth: 420 } }, { children: _jsx(BarraPesquisar, { filtrarGrid: setFiltro }) })), _jsx(TableContainer, __assign({ component: Paper, variant: 'outlined' }, { children: _jsxs(Table, __assign({ size: 'small' }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, { children: "Matr\u00EDcula" }), _jsx(TableCell, { children: "Colaborador" }), _jsx(TableCell, { children: "Benefici\u00E1rio / CPF" }), _jsx(TableCell, { children: "Dados Banc\u00E1rios" }), _jsx(TableCell, __assign({ align: 'right' }, { children: "A\u00E7\u00F5es" }))] }) }), _jsxs(TableBody, { children: [Vinculos.length === 0 && (_jsx(TableRow, { children: _jsx(TableCell, __assign({ colSpan: 5, align: 'center' }, { children: "Nenhum v\u00EDnculo encontrado." })) })), Vinculos.map(function (v) {
                                                var _a, _b, _c;
                                                return (_jsxs(TableRow, { children: [_jsx(TableCell, { children: (_a = v.colaborador) === null || _a === void 0 ? void 0 : _a.matricula }), _jsxs(TableCell, { children: [_jsx(Typography, __assign({ variant: 'body2', sx: { fontWeight: 600 } }, { children: (_b = v.colaborador) === null || _b === void 0 ? void 0 : _b.nome })), _jsxs(Typography, __assign({ variant: 'caption', color: 'textSecondary' }, { children: ["CPF: ", getCPFFormatado((_c = v.colaborador) === null || _c === void 0 ? void 0 : _c.cpf)] }))] }), _jsxs(TableCell, { children: [_jsx(Typography, __assign({ variant: 'body2', sx: { fontWeight: 600 } }, { children: v.nome })), _jsxs(Typography, __assign({ variant: 'caption', color: 'textSecondary' }, { children: ["CPF: ", getCPFFormatado(v.cpf)] }))] }), _jsxs(TableCell, { children: [_jsx(Typography, __assign({ variant: 'body2' }, { children: v.banco })), _jsxs(Typography, __assign({ variant: 'caption', color: 'textSecondary' }, { children: ["Ag: ", v.agencia, " \u2022 C/C: ", v.conta, v.digito ? "-".concat(v.digito) : ''] }))] }), _jsxs(TableCell, __assign({ align: 'right' }, { children: [_jsx(IconButton, __assign({ "aria-label": 'editar', color: 'primary', onClick: function () { return editarVinculo(v); } }, { children: _jsx(ModeEditOutlinedIcon, {}) })), _jsx(IconButton, __assign({ "aria-label": 'excluir', color: 'error', onClick: function () { return excluirVinculo(v); } }, { children: _jsx(DeleteOutlineIcon, {}) }))] }))] }, v.id));
                                            })] })] })) }))] })), loading && _jsx(Loading, {})] })) })));
};
export default VinculosGestao;
